<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <SemPermissao></SemPermissao>
            </div>
            <template v-if="!erro">
                <ExibirOnus :onus="onus" :temPermissao="temPermissao"/>
            </template>
        </div>
    </div>
</template>

<script>
    import OnusApi from "../../services/OnusApi";
    import SemPermissao from "../SemPermissao.vue"
    //import ErroResultados from "../../components/ErroResultados";
    import ExibirOnus from "../../components/onus/ExibirOnus.vue";
    import metaDados from "../../helpers/metaDados";
    import Auth from '../../services/Auth';

    export default {
        name: "OnusShow",
        metaInfo() {
            if (!this.onus) {
                return {};
            }

            let title = this.onus.nome;
            const description = this.onus.nome;

            return {
                title,
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                temPermissao: null,
                carregando: true,
                erro: false,
                onus: null,
            };
        },
        components: {
            //ErroResultados,
            SemPermissao,
            ExibirOnus,
        },
        created() {
            this.OnusApi = new OnusApi();
            let auth = new Auth();
            this.carregarOnus();
            this.temPermissao = auth.temPermissao;
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarOnus();
                }
            },
        },
        methods: {
            carregarOnus: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.OnusApi.cancelTokens.getOnus) {
                        this.OnusApi.cancelTokens.getOnus.cancel();
                    }

                    const dadosOnus = await this.OnusApi.getOnus(
                        this.$route.params.id
                    );
                    this.onus = dadosOnus

                    this.carregando = false;
                } catch (err) {
                    if (this.OnusApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.onus = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
</style>